module.exports = __webpack_public_path__ + "img/hero-product.d0b296cc.png";